import { tenant } from '@/tenants';

export function TenantLogo() {
  return (
    <img
      src={tenant.logoUrl}
      alt={`${tenant.variant} logo`}
      className="h-auto w-[146px]"
    />
  );
}
